import React, { useEffect, useState } from "react";
import { supabase, isSupabaseConfigured } from "../lib/supabase";

export default function AdminRoute({ children }) {
  const [loading, setLoading] = useState(true);
  const [allowed, setAllowed] = useState(false);
  const [message, setMessage] = useState("");

  useEffect(() => {
    checkAccess();
  }, []);

  async function checkAccess() {
    try {
      if (!isSupabaseConfigured || !supabase) {
        setMessage("Supabase n'est pas configuré.");
        setAllowed(false);
        return;
      }

      const {
        data: { session },
      } = await supabase.auth.getSession();

      if (!session?.user) {
        window.location.href = "/admin-login";
        return;
      }

      const { data: adminRow, error } = await supabase
        .from("app_admins")
        .select("id")
        .eq("user_id", session.user.id)
        .maybeSingle();

      if (error) {
        console.error(error);
        setMessage("Impossible de vérifier les droits administrateur.");
        setAllowed(false);
        return;
      }

      if (!adminRow) {
        setMessage("Accès refusé : vous n'êtes pas administrateur.");
        setAllowed(false);
        return;
      }

      setAllowed(true);
    } catch (error) {
      console.error(error);
      setMessage("Erreur lors de la vérification d'accès.");
      setAllowed(false);
    } finally {
      setLoading(false);
    }
  }

  if (loading) {
    return (
      <div style={styles.page}>
        <div style={styles.box}>Vérification des accès...</div>
      </div>
    );
  }

  if (!allowed) {
    return (
      <div style={styles.page}>
        <div style={styles.box}>{message || "Accès refusé."}</div>
      </div>
    );
  }

  return children;
}

const styles = {
  page: {
    minHeight: "100vh",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    background: "#0b1020",
    padding: "20px",
    color: "#fff",
  },
  box: {
    background: "#121933",
    border: "1px solid rgba(255,255,255,0.08)",
    borderRadius: "16px",
    padding: "24px",
    maxWidth: "520px",
    width: "100%",
    textAlign: "center",
  },
};